import MainContactSearch from '../../Containers/MainContactSearch/MainContactSearch';
import {useEffect, useState} from 'react';
import classes from './Header.module.css';
import LowerNavigation from './LowerNavigation/LowerNavigation';
import {Outlet, useLocation} from 'react-router-dom';

const Header = (props) => {
    const bgDefault = 'black';
    const bgChange = "black";

    const [contactSearchHeader, setContactSearchHeader] = useState(bgDefault);
    const [collapsed, setCollapsed] = useState(false);
    const [dropdowns, setDropdowns] = useState([]);
    const [scrolled, setScrolled] = useState(false);
    const [cover, setCover] = useState(false);
    const location = useLocation();


    useEffect(() => {
      if (Array.isArray(dropdowns)) {
        fetch('https://pasteleriavalentina-server.herokuapp.com/products')
             .then(resp => resp.json())
             .then(data => {
                 setDropdowns(data.reduce((curr, {category, product}) => {
                     curr[category] = Array.isArray(curr[category]) ?
                     [
                         ...curr[category],
                         product
                     ] :
                     [product]
                     return curr;
                 }, {}));
             });
      }

      if (Boolean(document.querySelector(".no-cover"))) {
  			if (!cover) {
  				setCover(true);
  			}
  		} else {
  			if (cover) {
  				setCover(false);
  			}
  		}
    }, [location])



    if (window.innerWidth < 900) {
        if (!collapsed) {
            setCollapsed(true);
        }
    }

    window.addEventListener("scroll", () => {
        if (window.scrollY > 100) {
            if (contactSearchHeader !== bgChange) {
                setContactSearchHeader(bgChange);
            }


        } else {
            if (contactSearchHeader === bgChange) {
                setContactSearchHeader(bgDefault)
            }
        }

        if (window.scrollY >= 520) {
          if (!scrolled) {
            setScrolled(true);
          }
        } else {
          if (scrolled) {
            setScrolled(false);
          }
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth < 900) {
            if (!collapsed) {
                setCollapsed(true);
            }
        } else {
            if (collapsed) {
                setCollapsed(false);
            }
        }
    })

    return (
        <>
            <MainContactSearch bgColor={contactSearchHeader}
                               insideColors={"white"}
                               cStyles={
                                {
                                    transition: 'all 1s',
                                }
                               }
                               searchBarClass={classes.searchBar}
                               collapsedState={collapsed}
                               dropdowns={Object.entries(dropdowns)}
                               links={[]}
                               size={['30px', '30px']}/>
           <Outlet/>
           <LowerNavigation cover={cover}
             dropdowns={dropdowns}
             scrolled={scrolled}
             collapsed={collapsed}/>
        </>
    )
}

export default Header;
